<template>
  <b-overlay :show="isLoading">
    <b-card>
      <h1 class="mb-2">ایجاد سوالات متداول جدید</h1>
      <b-row>
        <b-col cols="12">
          <faq-category-picker @getCategory="setCategory"></faq-category-picker>
        </b-col>
        <b-col cols="12">
          <b-form-group label="نامک (URL)" label-for="slug">
            <b-form-input
              id="slug"
              placeholder="post-ads-registration-conditions"
              v-model.trim="faqDetails.slug"
            ></b-form-input>
            <small class="text-danger">
              بهتر است از کلمات انگلیسی استفاده شود.
            </small>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="متن سوال" label-for="questionText">
            <b-form-input
              id="questionText"
              placeholder="شرایط ثبت آگهی در فرادیدار"
              v-model.trim="faqDetails.questionText"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="خلاصه جواب" label-for="summary">
            <b-form-textarea
              id="summary"
              v-model.trim="faqDetails.answerTextSummery"
              placeholder="خلاصه‌ی جواب برای نمایش در صفحات دسته بندی"
              rows="3"
              max-rows="3"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="متن جواب" label-for="answerText" class="mb-2">
            <ckEditorMain
              ref="ckEditor"
              id="answerText"
              :isRenderingSourceButton="false"
              @getEditorContent="setEditorContent"
            ></ckEditorMain>
          </b-form-group>
        </b-col>
        <b-col cols="12" align-self="end">
          <div class="w-100 d-flex align-items-center justify-content-end">
            <b-button
              :disabled="isSubmitButtonDisabled"
              variant="primary"
              @click="createNewFaqQuestionAnswer"
            >
              ثبت
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      faqDetails: {
        faqQuestionAnswerId: 0,
        faqCategoryId: null,
        questionText: null,
        answerText: null,
        answerTextSummery: null,
        order: 0,
      },
    };
  },
  methods: {
    async createNewFaqQuestionAnswer() {
      try {
        this.isLoading = true;
        const _this = this;
        let createFaqQuestionAnswer = new CreateFaqQuestionAnswer(_this);
        createFaqQuestionAnswer.setParams(_this.faqDetails);
        await createFaqQuestionAnswer.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: "ثبت شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "سوال متداول جدید با موفقیت ثبت شد",
              },
            });
            _this.$refs?.ckEditor?.resetData();
            _this.faqDetails = {
              faqQuestionAnswerId: 0,
              faqCategoryId: null,
              questionText: null,
              answerText: null,
              answerTextSummery: null,
              order: 0,
            };
          } else if (!res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: "ثبت نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errorMessage || "مشکلی پیش آمد، دوباره امتحان کنید.",
              },
            });
          }
          console.log(res);
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setEditorContent(content) {
      this.faqDetails.answerText = content;
    },
    setCategory(catObject) {
      if (catObject && catObject.id) {
        this.faqDetails.faqCategoryId = catObject.id;
      } else {
        this.faqDetails.faqCategoryId = null;
      }
    },
  },
  computed: {
    isSubmitButtonDisabled() {
      if (
        this.faqDetails &&
        this.faqDetails.faqCategoryId &&
        this.faqDetails.questionText &&
        this.faqDetails.slug &&
        this.faqDetails.answerTextSummery &&
        this.faqDetails.answerText
      ) {
        return false;
      }
      return true;
    },
  },
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BTabs,
    BTab,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BFormTextarea,
    BPagination,
    BFormGroup,
    BForm,
    BModal,
    FaqCategoryPicker,
    ckEditorMain,
  },
};

import ckEditorMain from "@core/components/ckEditorMain.vue";
import FaqCategoryPicker from "@/@core/utils/FaqCategoryPicker.vue";
import { CreateFaqQuestionAnswer } from "@/libs/Api/FaqQuestionAnswer/FaqQuestionAnswer";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {
  BOverlay,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BTabs,
  BTab,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BFormTextarea,
  BPagination,
  BFormGroup,
  BForm,
  BModal,
} from "bootstrap-vue";
</script>
